export default PrmUtilsService

/** @ngInject */
function PrmUtilsService() {
    const isCBE = function (metter_kind) {
        return ['CBE', 'CEB'].indexOf(metter_kind) > -1
    }

    const isEMC = function (metter_kind) {
        return ['EMC', 'CFB'].indexOf(metter_kind) > -1
    }

    const isLinky = function (metter_kind) {
        switch (metter_kind) {
            case 'AMM':
                return true
            case 'CCB':
                return true
            case 'LINKY':
                return true
            case 'CBE':
                return false
            case 'EMC':
                return false
            default:
                return false
        }
    }

    const isMigratedLinky = function (prm) {
        if (!isLinky(prm.metter_kind)) {
            return false
        }
        switch (prm.distributor_it) {
            case 'GINKO':
                return true
            case 'QETGC':
                return false
            default:
                return false
        }
    }

    return {
        isCBE,
        isEMC,
        isMigratedLinky,
        isLinky,
    }
}



// WEBPACK FOOTER //
// ./src/services/prmUtils/prmUtils.js